import { useTareas } from "../context/TareasContext"
import { FaTable, FaList, FaCalendarAlt, FaFileAlt } from "react-icons/fa"
import { MdViewKanban } from "react-icons/md"

const VIEWS = [
  { id: "paginas",    label: "Páginas",    Icon: FaFileAlt },
  { id: "tabla",      label: "Tabla",      Icon: FaTable },
  { id: "kanban",     label: "Kanban",     Icon: MdViewKanban },
  { id: "lista",      label: "Lista",      Icon: FaList },
  { id: "calendario", label: "Calendario", Icon: FaCalendarAlt },
]

const ViewSwitcher = () => {
  const { activeView, setActiveView } = useTareas()

  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-0.5 gap-0.5">
      {VIEWS.map(({ id, label, Icon }) => (
        <button
          key={id}
          onClick={() => setActiveView(id)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-150 ${
            activeView === id
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <Icon className="text-[13px]" />
          {label}
        </button>
      ))}
    </div>
  )
}

export default ViewSwitcher
